import { Menu, MenuItem, PopoverPosition } from "@mui/material";
import { mixpanel } from "common/analytics";
import { useTranslation } from "common/locales";
import { ReseedEvent } from "model";
import { Dispatch, SetStateAction } from "react";

interface Props {
  reseedEvent: ReseedEvent;
  anchor: HTMLElement | null;
  anchorPosition?: PopoverPosition;
  close: () => void;
  setDialogOpen: Dispatch<SetStateAction<boolean>>;
}
export default function ReseedEventMoreMenu({
  reseedEvent,
  anchor,
  anchorPosition,
  close,
  setDialogOpen,
}: Props) {
  const { t } = useTranslation();
  return (
    <Menu
      anchorEl={anchor}
      anchorPosition={anchorPosition}
      anchorReference={
        anchor ? "anchorEl" : anchorPosition ? "anchorPosition" : "none"
      }
      open={anchor ? anchor.id === reseedEvent.guid : false}
      onClose={close}
      key={`fe-menu-${reseedEvent.guid}`}
    >
      <MenuItem
        key={`fe-menuitem-edit-${reseedEvent.guid}`}
        onClick={() => {
          mixpanel.track("Edit/view re-seed event clicked");
          setDialogOpen(true);
          close();
        }}
      >
        {t("reseedEvent.menu.editView")}
      </MenuItem>
    </Menu>
  );
}
